import MenuContent from './menuContent.png';

export const menuContent = () => MenuContent;
